<template>
  <div class="actions">
    <router-link
      :to="{name: 'detail_traitement', params: {uid: object.uid}}"
      class="btn btn-secondary btn-sm"
    >
      <i class="icofont icofont-eye" />
    </router-link>
    <a
      class="btn btn-third btn-sm"
      @click.prevent="deleting"
      v-if="canDelete"
    ><i class="icofont icofont-close" /></a>
  </div>
</template>
  
  <script>
  import {mapGetters} from 'vuex'
  import { DELETE_TRAITEMENT } from '../../../graphql/sanitaire';
  export default {
      props : {
          object: {type: Object, required: true}
      },
      data(){
          return {
  
          }
      },
      methods: {
          deleting(){
              this.$apollo.mutate({
                  mutation: DELETE_TRAITEMENT,
                  variables: {
                      "uid": this.object.uid
                  },
                  update: (data) => {
                      if(data) console.log(`Traitement ${this.object.uid} deleted successfully`)
                      else console.log(`Error in deletting traitement ${this.object.uid}`)
                  }
                })
          }
      },
      computed: {
          ...mapGetters({
            is_super_admin: 'auth/is_super_admin',
            is_veterinaire: 'auth/is_veterinaire',
            is_assistant_veterinaire: 'auth/is_assistant_veterinaire',
            is_assistant_veto_major: 'auth/is_assistant_veto_major',
          }),
          canDelete(){
            return this.is_super_admin ||
              this.is_veterinaire ||
              this.is_assistant_veto_major
          }
          
      }
  
  }
  </script>
  
  <style>
  
  </style>